// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateArgentineDocumentType(documentType: string): ?UserInputValidationError {
  if (documentType !== 'DNI' && documentType !== 'CUIL' && documentType !== 'CUIT' && documentType !== 'CDI')
    return { id: 'invalid-argentine-document-type' };
}
